import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Box, Typography, Alert, LinearProgress
} from '@mui/material';
import { CloudUpload as UploadIcon } from '@mui/icons-material';
import { pescaService } from '../../services/pescaService';

const ImportadorLiquidacion = ({ open, onClose, rutEmpresa, onImportado }) => {
  const [archivo, setArchivo] = useState(null);
  const [importando, setImportando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [error, setError] = useState('');

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && (file.name.endsWith('.xlsx') || file.name.endsWith('.xls'))) {
      setArchivo(file);
      setError('');
      setResultado(null);
    } else {
      setError('Solo se aceptan archivos Excel (.xlsx, .xls)');
      setArchivo(null);
    }
  };

  const handleImportar = async () => {
    if (!archivo) return;
    setImportando(true);
    setError('');
    setResultado(null);

    try {
      const res = await pescaService.importarExcel(archivo, rutEmpresa);
      setResultado(res);
      if (onImportado) onImportado(res);
    } catch (err) {
      const msg = err?.detail || err?.message || 'Error al importar archivo';
      setError(typeof msg === 'string' ? msg : JSON.stringify(msg));
    } finally {
      setImportando(false);
    }
  };

  const handleClose = () => {
    setArchivo(null);
    setResultado(null);
    setError('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Importar Liquidación desde Excel</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Seleccione un archivo Excel con formato de liquidación PRAMAR.
            Se importarán capturas, gastos, viajes y tripulación automáticamente.
          </Typography>

          <Button variant="outlined" component="label" startIcon={<UploadIcon />}>
            {archivo ? archivo.name : 'Seleccionar archivo'}
            <input type="file" hidden accept=".xlsx,.xls" onChange={handleFileChange} />
          </Button>

          {importando && <LinearProgress />}

          {error && <Alert severity="error">{error}</Alert>}

          {resultado && (
            <Alert severity="success">
              <Typography variant="subtitle2">Importación exitosa</Typography>
              <Typography variant="body2">
                Liquidación #{resultado.liquidacion_id} creada
                {resultado.capturas > 0 && ` - ${resultado.capturas} capturas`}
                {resultado.gastos > 0 && ` - ${resultado.gastos} gastos`}
                {resultado.viajes > 0 && ` - ${resultado.viajes} viajes`}
                {resultado.tripulantes_nuevos > 0 && ` - ${resultado.tripulantes_nuevos} tripulantes nuevos`}
              </Typography>
            </Alert>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{resultado ? 'Cerrar' : 'Cancelar'}</Button>
        {!resultado && (
          <Button onClick={handleImportar} variant="contained" disabled={!archivo || importando}>
            {importando ? 'Importando...' : 'Importar'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ImportadorLiquidacion;
